import React from 'react';

import {
  Box,
  Button,
  styled
} from '@mui/material';
import {
  BaseWidget,
  InitiateReturnModal,
  PermissionWall,
  SendChatMessageModal
} from 'modules';

import { modalUtil } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const RootBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between'
});

const FlexBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));



export interface IProps {
  storeId: string;
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'initiateReturn',
    'addAuditLogEvent',
    'sendChatMessage'
    // 'sendEmail',
  ]);
  const tuple = dataService.useQuery(props.orderId);
  const [closeOrder, closeOrderTuple] = dataService.useCloseOrder(props.orderId);



  function handleClickCloseOrder() {
    const shouldCancelOrder = window.confirm("Are you sure you want to close this order? This action is irreversible.");
    if (shouldCancelOrder) {
      closeOrder();
    }
  }

  function handleClickAddNote() {
    setModalIsOpen('addAuditLogEvent', true);
  }

  // function handleEmailCustomer() {
  //   setModalIsOpen('sendEmail', true);
  // }

  function handleMessageCustomer() {
    setModalIsOpen('sendChatMessage', true);
  }

  function handleClickInitiateReturn() {
    if (!tuple.data.hasReturnAuthorization) {
      setModalIsOpen('initiateReturn', true);

    } else if (window.confirm("A return already exists on this order. Are you sure you want to open another?")) {
      setModalIsOpen('initiateReturn', true);
    }
  }

  function handleCloseInitiateReturnModal() {
    setModalIsOpen('initiateReturn', false);
  }

  function handleCloseSendChatMessage() {
    setModalIsOpen('sendChatMessage', false);
  }

  // function handleCloseAddAuditLogEventModal() {
  //   setModalIsOpen('addAuditLogEvent', false);
  //   // setModalIsOpen('sendEmail', false);
  // }


  const loading = closeOrderTuple.loading;

  return (
    <>
      <BaseWidget.FC>
        <RootBox>
          <FlexBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['salesOrder_addAuditLogEvent']}>
              <Button
                disabled={!tuple.called || loading}
                variant="contained"
                onClick={handleClickAddNote}>
                Add Note
              </Button>
            </PermissionWall.FC>

            {/* <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['customer_email']}>
              <Button
                disabled={!tuple.called || loading}
                variant="contained"
                onClick={handleEmailCustomer}>
                Email Customer
              </Button>
            </PermissionWall.FC> */}

            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['salesOrder_sendMessage']}>
              <Button
                disabled={!tuple.called || loading}
                variant="contained"
                onClick={handleMessageCustomer}>
                Message Customer
              </Button>
            </PermissionWall.FC>
          </FlexBox>

          <FlexBox>
            {tuple.data.canCloseOrder && (
              <PermissionWall.FC
                storeId={props.storeId}
                requiresPermissions={['salesOrder_cancel']}>
                <Button
                  disabled={!tuple.called || loading || !tuple.data.canCloseOrder}
                  variant="contained"
                  onClick={handleClickCloseOrder}>
                  {tuple.data.canCloseOrder ? "Close Order" : "Cannot close order"}
                </Button>
              </PermissionWall.FC>
            )}

            {tuple.data.canInitiateReturnAuthorization && (
              <PermissionWall.FC
                storeId={props.storeId}
                requiresPermissions={['returnAuthorization_create']}>
                <Button
                  disabled={!tuple.called || loading}
                  variant="contained"
                  onClick={handleClickInitiateReturn}>
                  Initiate Return
                </Button>
              </PermissionWall.FC>
            )}
          </FlexBox>
        </RootBox>
      </BaseWidget.FC>

      {modalType2IsOpen.initiateReturn && (
        <InitiateReturnModal.FC
          orderId={props.orderId}
          onClose={handleCloseInitiateReturnModal} />
      )}

      {modalType2IsOpen.sendChatMessage && (
        <SendChatMessageModal.FC
          orderId={props.orderId}
          onClose={handleCloseSendChatMessage} />
      )}

      {/* {(modalType2IsOpen.addAuditLogEvent || modalType2IsOpen.sendEmail) && (
        <AddAuditLogEventModal.FC
          sendsEmail={modalType2IsOpen.sendEmail}
          orderId={props.orderId}
          onClose={handleCloseAddAuditLogEventModal} />
      )} */}
    </>
  );
};
